import styles from './GridUnitsLayout.module.scss'
import DropBox from '../card/DropBox'
import { AusCourseContent } from '@src/api/graphql-codegen'
import CoverContent from '@src/components/CoverContent/CoverContent'

type Props = {
    contents: AusCourseContent[]
    source: string
    target?: string
    isAusCourse?: boolean
    handleDrop: (index: number, unit: AusCourseContent) => void
    handleRemoveContentAction?: (unit: AusCourseContent) => void
    isNewMovable?: boolean  // New Cover moving state
}

function GridAusCourseContentLayout(props: Props) {
    const { contents, source, target, isAusCourse, isNewMovable, handleDrop, handleRemoveContentAction } = props

    const isAllUnits = source === "origin"

    let index = 0
    switch (source) {
        case 'grade':
            index = 1
            break
        case 'addition':
            index = 2
            break
        case 'origin':
            index = 0
            break
        default:
            index = 0
            break
    }

    return (
        <div className={isAllUnits ? styles.unitsDiv : styles.normalDiv }>
            {isAllUnits &&
                <DropBox
                    accept={"type"}
                    source={source}
                    onDrop={(item) => handleDrop(index, item)}
                />
            }
            {(contents || []).map((content, index) => {
                return (
                    <CoverContent
                        key={index}
                        type={"type"}
                        source={source}
                        target={target}
                        content={content}
                        handleRightArrowAction={() => handleRemoveContentAction && handleRemoveContentAction(content)}
                    />
                )
            }
            )}
            {!isAllUnits &&
                <DropBox
                    accept={"type"}
                    source={source}
                    onDrop={(item) => handleDrop(index, item)}
                    isAusCourse={isAusCourse}
                    isNewMovable={isNewMovable}
                />
            }
        </div>
    )
}

export default GridAusCourseContentLayout